/*
 * cc-cod-calculator.js — CloseCaption Store
 * COD landing page: anticipo calculation + delivery dates + urgency + FAQ
 * ZERO jQuery, ZERO external APIs — vanilla JS + /cart.js only
 */
(function(root){
  var SHIPPING_BASE=20000;
  var COD_FEE_PER_UNIT=5000;
  var FREE_SHIPPING_THRESHOLD=250000;

  function calculateCodPayment(orderValue,quantity){
    orderValue=Number(orderValue)||0;
    quantity=Math.max(1,parseInt(quantity,10)||1);
    var freeShipping=orderValue>FREE_SHIPPING_THRESHOLD;
    var shippingCost=SHIPPING_BASE;
    var codFee=quantity*COD_FEE_PER_UNIT;
    var anticipo,pagoRecibir;
    if(quantity<=2){anticipo=SHIPPING_BASE;pagoRecibir=orderValue+codFee;}
    else{anticipo=SHIPPING_BASE+codFee;pagoRecibir=orderValue;}
    if(freeShipping) pagoRecibir-=SHIPPING_BASE;
    return{anticipo:anticipo,pago_recibir:pagoRecibir,total_cliente:anticipo+pagoRecibir,free_shipping:freeShipping,shipping_cost:shippingCost,cod_fee:codFee,shipping_base:SHIPPING_BASE,cod_fee_per_unit:COD_FEE_PER_UNIT,quantity:quantity,order_value:orderValue};
  }

  function formatCOP(n){
    n=Math.round(Number(n)||0);
    return '$'+n.toString().replace(/\B(?=(\d{3})+(?!\d))/g,'.');
  }

  function addBusinessDays(date,days){
    var d=new Date(date);
    var added=0;
    while(added<days){d.setDate(d.getDate()+1);if(d.getDay()!==0) added++;}
    return d;
  }

  var MONTHS=['ene','feb','mar','abr','may','jun','jul','ago','sep','oct','nov','dic'];
  var DAYS=['dom','lun','mar','mié','jue','vie','sáb'];
  function fmtDate(d){return DAYS[d.getDay()]+' '+d.getDate()+' '+MONTHS[d.getMonth()];}

  function renderCartItems(container,cart){
    if(!container) return;
    container.innerHTML=cart.items.map(function(item){
      var img=item.image||'';
      var title=item.product_title||item.title||'';
      var variant=item.variant_title||'';
      return '<li class="cc-cod-item">'
        +(img?'<img src="'+img.replace(/(\.\w+)\?/,'_120x120$&')+'" alt="'+title.replace(/"/g,'&quot;')+'" class="cc-cod-item__img" width="64" height="64">':'')
        +'<div class="cc-cod-item__body">'
        +'<div class="cc-cod-item__title">'+title+'</div>'
        +(variant?'<div class="cc-cod-item__variant">Talla: '+variant+'</div>':'')
        +'<div class="cc-cod-item__meta">Cant: '+item.quantity+' &middot; '+formatCOP((item.final_price||item.price)/100)+'</div>'
        +'</div></li>';
    }).join('');
  }

  function renderBreakdown(container,cart){
    if(!container) return;
    var ov=cart.total_price/100;
    var qty=cart.item_count;
    var r=calculateCodPayment(ov,qty);
    var set=function(sel,val){var el=container.querySelector(sel);if(el) el.textContent=val;};
    set('[data-cc-cod="subtotal"]',formatCOP(r.order_value));
    set('[data-cc-cod="cod-fee"]',formatCOP(r.cod_fee));
    set('[data-cc-cod="anticipo"]',formatCOP(r.anticipo));
    set('[data-cc-cod="pago-recibir"]',formatCOP(r.pago_recibir));
    set('[data-cc-cod="total"]',formatCOP(r.total_cliente));
    var subtotalLabel=container.querySelector('[data-cc-cod="subtotal-label"]');
    if(subtotalLabel) subtotalLabel.textContent='Subtotal productos ('+r.quantity+')';
    var codFeeLabel=container.querySelector('[data-cc-cod="cod-fee-label"]');
    if(codFeeLabel) codFeeLabel.textContent=r.quantity>1?'Tarifa contraentrega × '+r.quantity+' (Interrapidísimo)':'Tarifa contraentrega (Interrapidísimo)';
    var shippingEl=container.querySelector('[data-cc-cod="shipping"]');
    if(shippingEl){
      if(r.free_shipping){
        shippingEl.textContent='Gratis';
        shippingEl.classList.add('cc-cod__breakdown-value--free');
      } else {
        shippingEl.textContent=formatCOP(r.shipping_cost);
        shippingEl.classList.remove('cc-cod__breakdown-value--free');
      }
    }
    var freeEl=container.querySelector('[data-cc-cod="free-shipping"]');
    if(freeEl){
      freeEl.style.display=r.free_shipping?'':'none';
      if(r.free_shipping) freeEl.innerHTML='🎉 Tu pedido supera $250.000 — <strong>envío gratis incluido</strong>. El anticipo de '+formatCOP(r.anticipo)+' se descuenta de lo que pagas al recibir.';
    }
    return r;
  }

  // ing-c (2026-10-13): con camiseta en el carrito suma 1-2 días hábiles de estampado (3-5 → 4-7);
  // en preventa (data-cc-prev-fecha = AAAA-MM-DD del ajuste del tema) cuenta desde la fecha de despacho (+2 a +4).
  // Carrito solo de gorras: 3-5 como siempre.
  function renderDelivery(container,cart){
    if(!container) return;
    var now=new Date();
    var page=container.closest?container.closest('[data-cc-cod-page]'):null;
    var hasCam=!!(page&&parseInt(page.getAttribute('data-cc-cam'),10)>0);
    if(!hasCam&&cart&&cart.items){for(var i=0;i<cart.items.length;i++){if(cart.items[i].product_type==='Camiseta'){hasCam=true;break;}}}
    var prev=page?(page.getAttribute('data-cc-prev-fecha')||''):'';
    var minArr=addBusinessDays(now,3);
    var maxArr=addBusinessDays(now,5);
    if(hasCam){minArr=addBusinessDays(now,4);maxArr=addBusinessDays(now,7);}
    var pm=/^(\d{4})-(\d{2})-(\d{2})$/.exec(prev);
    if(pm){
      var desp=new Date(+pm[1],+pm[2]-1,+pm[3]);
      if(desp>now){minArr=addBusinessDays(desp,2);maxArr=addBusinessDays(desp,4);}
    }
    var msg=container.querySelector('[data-date="range"]');
    if(msg) msg.innerHTML='<strong>entre el '+fmtDate(minArr)+' y el '+fmtDate(maxArr)+'</strong>';
  }

  function renderStock(container,cart){
    if(!container) return;
    var stockEl=container.querySelector('[data-stock-qty]');
    var barEl=container.querySelector('[data-stock-bar]');
    var textEl=container.querySelector('[data-stock-text]');
    if(!stockEl) return;
    var qty=parseInt(stockEl.getAttribute('data-stock-qty'),10);
    if(!qty||qty>10){container.style.display='none';return;}
    container.style.display='';
    if(textEl) textEl.textContent='Solo quedan '+qty+' unidades en tu talla';
    if(barEl){
      var pct=Math.min(qty*10,100);
      barEl.style.width=pct+'%';
      barEl.style.background=qty<=3?'#d32f2f':qty<=6?'#ffa000':'#43a047';
    }
  }

  function initFaq(){
    document.querySelectorAll('.cc-cod__faq-item').forEach(function(item){
      var q=item.querySelector('.cc-cod__faq-q');
      if(!q) return;
      q.addEventListener('click',function(){item.classList.toggle('open');});
    });
  }

  // v3 — Puebla hero "dos momentos" + desglose visible + gate + CTA (docked y sticky)
  // desde r de calculateCodPayment. Null-safe: en v1 (sin estos elementos) no hace nada.
  function populateConfirmV3(page,r){
    if(!page||!r) return;
    var setAll=function(sel,val){
      var nodes=page.querySelectorAll(sel);
      for(var i=0;i<nodes.length;i++) nodes[i].textContent=val;
    };
    var anticipoFmt=formatCOP(r.anticipo);
    // Hero dos momentos
    setAll('[data-cc-cod="now-amount"]',anticipoFmt);
    setAll('[data-cc-cod="receive-amount"]',formatCOP(r.pago_recibir));
    // Desglose transparente (gorra + envío + pago contra entrega = total)
    setAll('[data-cc-cod="bd-gorra"]',formatCOP(r.order_value));
    var envioEl=page.querySelector('[data-cc-cod="bd-envio"]');
    if(envioEl){
      if(r.free_shipping){ envioEl.textContent='Gratis'; envioEl.classList.add('cc-cod__il-value--free'); }
      else { envioEl.textContent=formatCOP(r.shipping_base); envioEl.classList.remove('cc-cod__il-value--free'); }
    }
    var freeNote=page.querySelector('[data-cc-cod="bd-envio-free-note"]');
    if(freeNote) freeNote.style.display=r.free_shipping?'':'none';
    setAll('[data-cc-cod="bd-codfee"]',formatCOP(r.cod_fee));
    setAll('[data-cc-cod="bd-total"]',formatCOP(r.total_cliente));
    var codFeeLabel=page.querySelector('[data-cc-cod="bd-codfee-label"]');
    if(codFeeLabel && r.quantity>1) codFeeLabel.textContent='📦 Pago contra entrega × '+r.quantity;
    // Gate + CTA (docked + sticky comparten el monto)
    setAll('[data-cc-cod="gate-anticipo"]',anticipoFmt);
    setAll('[data-cc-cod="gate-expect-anticipo"]',anticipoFmt);
    setAll('[data-cc-cod="cta-amount"]',anticipoFmt);
    setAll('[data-cc-cod="cta-amount-sticky"]',anticipoFmt);
    // Link de ayuda WhatsApp con anticipo precargado
    var waLink=page.querySelector('[data-cc-cod="wa-help"]');
    if(waLink){
      var msg='Hola, tengo una duda sobre mi pedido contra entrega (entiendo que el anticipo de '+anticipoFmt+' es para despachar).';
      waLink.href='https://wa.me/573204815839?text='+encodeURIComponent(msg);
    }
  }

  // v3b — Barra de progreso dinámica. Reusa los eventos ya cableados (no detecta nada nuevo):
  //   reach2() <- 1er intersect del gate_cta · checked(on) <- change del checkbox · done() <- doConfirm.
  // Idempotente: el observer solo avanza (no retrocede por re-intersección); desmarcar vuelve a paso 2.
  // Mantiene la franja pegada al bottom REAL del sticky-header (Dawn on-scroll-up):
  // header visible -> top = altura del header · header oculto/sin header -> top = 0. Sin hueco.
  function dockProgressTop(strip){
    var header=document.querySelector('sticky-header');
    function update(){
      if(!header){ strip.style.top='0px'; return; }
      var b=header.getBoundingClientRect().bottom;
      strip.style.top=Math.max(0,Math.round(b))+'px';
    }
    update();
    var ticking=false;
    function onScroll(){ if(!ticking){ ticking=true; requestAnimationFrame(function(){ update(); ticking=false; }); } }
    window.addEventListener('scroll',onScroll,{passive:true});
    window.addEventListener('resize',update);
  }

  function initProgress(page){
    var strip=page.querySelector('[data-cc-progress]');
    if(!strip) return null;
    dockProgressTop(strip);   // fix A: pega la franja al header sin hueco
    var fill=page.querySelector('[data-cc-cod="progress-fill"]');
    var curEl=page.querySelector('[data-cc-cod="progress-current"]');
    var nxtEl=page.querySelector('[data-cc-cod="progress-next"]');
    var D={
      1:{w:'0%', n:'1/3',label:strip.getAttribute('data-s1'),next:strip.getAttribute('data-s1n')},
      2:{w:'33%',n:'2/3',label:strip.getAttribute('data-s2'),next:strip.getAttribute('data-s2n')},
      3:{w:'66%',n:'3/3',label:strip.getAttribute('data-s3'),next:strip.getAttribute('data-s3n')}
    };
    var doneTxt=strip.getAttribute('data-done')||'¡Listo! Redirigiendo…';
    var state=1;
    function apply(n){
      if(n==='done'){
        if(fill) fill.style.width='100%';
        if(curEl) curEl.textContent='✓ '+doneTxt;
        if(nxtEl) nxtEl.style.display='none';
        state='done'; return;
      }
      var d=D[n]; if(!d) return;
      if(fill) fill.style.width=d.w;
      if(curEl) curEl.textContent='Paso '+d.n+' · '+d.label;
      if(nxtEl){ nxtEl.style.display=''; nxtEl.textContent='▸ sigue: '+d.next; }
      state=n;
    }
    return {
      reach2:function(){ if(state===1) apply(2); },                 // 1er intersect del gate: paso 1 -> 2 (solo avanza)
      checked:function(on){
        if(state==='done') return;
        if(on){ apply(3); }                                         // marcó la casilla -> paso 3
        else if(state===3){ apply(2); }                             // desmarcó desde paso 3 -> vuelve a paso 2
        // on=false con state 1/2 (ej. carga inicial): NO tocar -> respeta el avance por scroll
      },
      done:function(){ apply('done'); }
    };
  }

  // v3 — Cableado interactivo: gate ↔ ambos botones, sticky-float (IntersectionObserver),
  // confirmar (guard + redirect preview-safe), progress. Independiente del cart (no atrapa).
  function initConfirmV3(page){
    if(!page || !page.hasAttribute('data-cc-cod-v3')) return;
    function buildUrl(path){
      var p=new URLSearchParams(window.location.search);
      var pid=p.get('preview_theme_id');
      var sep=path.indexOf('?')>-1?'&':'?';
      return pid?path+sep+'preview_theme_id='+pid:path;
    }
    var gate=page.querySelector('#cc-cod-gate');
    var gateBox=page.querySelector('[data-cc-gate-box]');
    var gateCta=page.querySelector('[data-cc-gate-cta]');
    var sticky=page.querySelector('[data-cc-sticky-float]');
    var hint=page.querySelector('[data-cc-cod="sticky-hint"]');
    var buttons=page.querySelectorAll('[data-cc-confirm]');

    // Barra de progreso dinámica (sin animación ciega; arranca en 12% server-rendered)
    var progress=initProgress(page);

    // 6-oct [2c] C: casilla espejo en la barra fija; las dos quedan siempre iguales.
    var mirror=page.querySelector('[data-cc-gate-mirror]');
    var mirrorWrap=page.querySelector('[data-cc-gate-mirror-wrap]');
    if(mirror && gate){
      mirror.addEventListener('change',function(){ gate.checked=mirror.checked; refresh(); });
    }

    function refresh(){
      if(!gate) return;
      if(mirror) mirror.checked=gate.checked;
      if(mirrorWrap) mirrorWrap.style.display=gate.checked?'none':'';
      for(var i=0;i<buttons.length;i++){
        if(gate.checked){ buttons[i].classList.remove('cc-cod__cta-btn--disabled'); buttons[i].setAttribute('aria-disabled','false'); }
        else { buttons[i].classList.add('cc-cod__cta-btn--disabled'); buttons[i].setAttribute('aria-disabled','true'); }
      }
      if(gate.checked && hint) hint.style.display='none';
      if(progress) progress.checked(gate.checked);   // marca -> paso 3 · desmarca -> paso 2
    }
    if(gate){ refresh(); gate.addEventListener('change',refresh); }   // habilitado en HTML crudo; JS lo deshabilita

    function guideToGate(){
      if(gateBox){
        gateBox.scrollIntoView({behavior:'smooth',block:'center'});
        gateBox.classList.add('cc-cod__gate--pulse');
        setTimeout(function(){gateBox.classList.remove('cc-cod__gate--pulse');},1600);
      }
      if(hint) hint.style.display='';
    }
    function doConfirm(){
      if(gate && !gate.checked){ guideToGate(); return; }
      if(progress) progress.done();   // paso 3 ✓ -> 100% + "¡Listo! Redirigiendo…"
      for(var i=0;i<buttons.length;i++) buttons[i].classList.add('cc-cod__cta-btn--disabled');
      var dock=page.querySelector('#cc-cod-confirm-btn');
      if(dock) dock.textContent='Redirigiendo al checkout...';
      try{ if(typeof fbq==='function'){ fbq('track','InitiateCheckout',{content_type:'product',currency:'COP'}); } }catch(e){}
      window.location.href=buildUrl('/checkout');
    }
    for(var i=0;i<buttons.length;i++) buttons[i].addEventListener('click',doConfirm);

    // Sticky-float: visible solo mientras gate_cta está fuera de pantalla (patrón cc-pdp-v2)
    if(sticky && gateCta && 'IntersectionObserver' in window){
      var io=new IntersectionObserver(function(entries){
        entries.forEach(function(entry){
          var visible=!entry.isIntersecting;
          sticky.setAttribute('data-visible',visible?'true':'false');
          sticky.setAttribute('aria-hidden',visible?'false':'true');
          if(entry.isIntersecting && progress) progress.reach2();   // 1er intersect del gate -> paso 1 ✓
        });
      },{threshold:0,rootMargin:'0px 0px -20px 0px'});
      // 6-oct [2c]: con la casilla arriba (orden nuevo), el borde del bloque asomaba en el primer pantallazo y la
      // barra no salía aunque el botón seguía fuera de vista. Se observa el botón: barra visible mientras no se vea.
      io.observe(page.querySelector('#cc-cod-confirm-btn')||gateCta);
    }
  }

  function initConfirmarPage(){
    var page=document.querySelector('[data-cc-cod-page]');
    if(!page) return;
    initConfirmV3(page);   // cableado v3 antes del fetch (no atrapa si el fetch falla)

    fetch('/cart.js',{headers:{'Accept':'application/json'}})
    .then(function(r){return r.json();})
    .then(function(cart){
      if(!cart.items||!cart.items.length){
        var empty=page.querySelector('[data-cc-cod="empty"]');
        var content=page.querySelector('[data-cc-cod="content"]');
        var sticky=page.querySelector('[data-cc-sticky-float]');
        if(empty) empty.style.display='';
        if(content) content.style.display='none';
        if(sticky) sticky.style.display='none';
        return;
      }
      renderCartItems(page.querySelector('[data-cc-cod="items"]'),cart);
      var r=calculateCodPayment(cart.total_price/100,cart.item_count);
      renderBreakdown(page.querySelector('[data-cc-cod-breakdown]'),cart);  // v1: puebla su desglose (null-safe)
      populateConfirmV3(page,r);                                            // v3: hero/desglose/gate/CTA/sticky
      renderDelivery(page.querySelector('[data-cc-delivery]'),cart);
      renderStock(page.querySelector('[data-cc-stock]'),cart);
      initFaq();
    })
    .catch(function(e){console.error('Error cargando carrito COD:',e);});
  }

  if(document.readyState==='loading'){
    document.addEventListener('DOMContentLoaded',initConfirmarPage);
  }else{
    initConfirmarPage();
  }
})();
